import { jsx, css } from '@emotion/react';

import ContentAndImage from '../oc-content-and-image';
import FileBadge from '../oc-file-badge';
import Link from '../oc-link';

import getExtension from '../utilities/file-extension';
import _ from 'lodash';

import RichText from "../oc-rich-text"

const styles = css`
  .bullet-points {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;

    margin-top: 32px;
    padding: 0;

    &.hide {
      display: none;
    }

    @media (max-width: 767px) {
      margin-bottom: 56px;
      padding-bottom: 36px;
    }

    li {
      width: calc(50% - 20px);
      margin: 0 0 20px 20px;

      @media (max-width: 767px) {
        width: calc(100% - 20px);
      }
    }
  }

  .with-media {
    margin-bottom: 64px;
    margin-top: 32px;
    padding: 0;

    .content i.fa {
      margin-left: 10px;
    }

    &.hide {
      display: none;
    }

    &.with-border-top {
      padding-top: 64px;
    }

    &.no-border {
      border: 0;
    }
  }

  .with-border-top {
    border-top: 2px solid #000000;
  }

  .with-border-bottom {
    border-bottom: 2px solid #000000;
  }
`;

const MarqueeFeatures = ({ bulletPoints, withMedia, hasMainItems=true }) => {
  return (
    <div css={styles} >
      <div className={ (withMedia.length || bulletPoints.length) ? null : 'with-border-bottom' } />
      <ul className={`bullet-points ${bulletPoints.length ? '' : 'hide'} ${ withMedia.length ? '' : 'with-border-bottom'}`}>
          {bulletPoints.map((feature, i) => (
            feature.name &&
              <li key={i}>
                <h3 className="h4"><RichText content={feature.name}/></h3>
                <p><RichText content={_.get(feature, 'copy.value')}/></p>
              </li>
          ))}
      </ul>
      <div className={`with-media ${(hasMainItems || bulletPoints.length) ? 'with-border-top with-border-bottom' : 'no-border'} ${withMedia.length ? null : 'hide'}`}>
        {withMedia.map((feature, i) => (
          <ContentAndImage key={i} contentOrder={ i%2 ? 'last' : 'first' } ratio="1-1" img={_.get(feature, 'images.banner.url')} video={feature.youtubeId}>
            <h3><RichText content={feature.name}/></h3>
            <p><RichText content={_.get(feature, 'copy.value')}/></p>
            {_.get(feature, 'document.url') ?
              <p>
                <Link
                  href={_.get(feature, 'document.url')}
                  data-track="file-download"
                  data-track-file-type={getExtension(_.get(feature, 'document.url'))}
                  data-track-file-name={_.get(feature, 'document.name')}
                  data-track-doc-type={_.get(feature, 'document.type')}
                  data-track-element-location="main section text link"
                  target="_blank"
                >
                  {_.get(feature, 'document.name')}
                  <FileBadge extension={getExtension(_.get(feature, 'document.url'))} sizeBytes={_.get(feature, 'document.size_bytes')} />
                </Link>
              </p>
            : null}
            {_.get(feature, 'feature.link[0].url') ?
              <p>
                <Link
                  href={_.get(feature, 'feature.link[0].url')}
                  data-track="learn-more"
                  data-track-element-location="main section text link"
                >
                  {_.get(feature, 'feature.link[0].value')}
                  <Icon type="external-link" />
                </Link>
              </p>
            : null}
          </ContentAndImage>
        ))}
      </div>
    </div>
  );
};

export default MarqueeFeatures;
